import * as momentTimezone from "moment-timezone";
import * as moment from "moment";

function round(value, precision) {
    const multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
}

export const roundedFloat = value => {
    value = parseFloat(value);
    return round(value, 2).toFixed(2);
};

export function calculateDayAndNightPrice(product, dayPrice, nightPrice, yearlyEstimatedConsumption, baseFee) {
    const sixty = (yearlyEstimatedConsumption * 0.6) * convertFeeToCents(dayPrice);
    const forty = (yearlyEstimatedConsumption * 0.4) * convertFeeToCents(nightPrice);
    const yearlyTotal = roundedFloat((+sixty + +forty + +baseFee * 12));
    return {
        ID: product.ID,
        dayFee: roundedFloat(dayPrice),
        nightFee: roundedFloat(nightPrice),
        generalFee: roundedFloat(baseFee),
        totalSum: yearlyTotal
    };
}

export function calculateSeasonalPrices(product, yearlyEstimatedConsumption, seasonalFee_27, seasonalFee_73, baseFee) {
    const seasonal27_Price = (yearlyEstimatedConsumption * 0.27) * convertFeeToCents(seasonalFee_27);
    const seasonal73_Price = (yearlyEstimatedConsumption * 0.73) * convertFeeToCents(seasonalFee_73);
    const yearlyTotal = roundedFloat((+seasonal27_Price + +seasonal73_Price + +baseFee * 12));
    return {
        ID: product.ID,
        seasonalFee_27: roundedFloat(seasonalFee_27),
        seasonalFee_73: roundedFloat(seasonalFee_73),
        generalFee: roundedFloat(baseFee),
        totalSum: yearlyTotal
    }
}

export function calculateWinterAndSpotPrices(product, yearlyEstimatedConsumption, winterFee, spotFee, baseFee) {
    const winterPrice = (yearlyEstimatedConsumption * 0.43) * convertFeeToCents(winterFee);
    const spotPrice = (yearlyEstimatedConsumption * 0.57) * convertFeeToCents(spotFee);
    const yearlyTotal = roundedFloat((+winterPrice + +spotPrice + +baseFee * 12));
    return {
        ID: product.ID,
        winterFee: roundedFloat(winterFee),
        spotFee: roundedFloat(spotFee),
        totalSum: yearlyTotal
    }
}

export function calculateYearlyAverageSpotPriceTotalBasedOnConsumption(product, yearlyEstimatedConsumption, eurokWh, generalFee, baseFee) {
    const yearlyBaseFee = Number(baseFee) * 12;
    const yearlyTotal = (yearlyEstimatedConsumption * eurokWh) + yearlyBaseFee;

    return {
        ID: product.ID,
        avgEnergyFee: roundedFloat(generalFee),
        generalFee: roundedFloat(baseFee),
        totalSum: roundedFloat(yearlyTotal)
    }
}

export function calculateYearlyTotalBasedOnConsumption(product, yearlyEstimatedConsumption, eurokWh, generalFee, baseFee) {
    const yearlyTotal = roundedFloat((yearlyEstimatedConsumption * eurokWh + +baseFee * 12));
    return {
        ID: product.ID,
        energyFee: roundedFloat(generalFee),
        generalFee: roundedFloat(baseFee),
        totalSum: yearlyTotal
    }
}

function convertFeeToCents(fee) {
    return (fee / 100);
}

export function validatesEmailForm(email) {
    return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email);
}

function isValidDate(day, month, year) {
    if (year < 100) { // accounts for 2 digit years
        year += 2000; // 2000 or 1900 makes no difference here
    }
    const date = new Date(year, month - 1, day); // month is 0-indexed
    return date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day;
}

function validateDateString(dateString) {
    const dateRegex = /^(0[1-9]|[12][0-9]|3[01])(0[1-9]|1[0-2])([0-9]{2})$/;
    if (!dateRegex.test(dateString)) {
        return false;
    }

    const day = parseInt(dateString.substring(0, 2), 10);
    const month = parseInt(dateString.substring(2, 4), 10);
    const year = parseInt(dateString.substring(4, 6), 10)

    return isValidDate(day, month, year);
}

export function validateSocialSecurityNumber(socialSecurityNumber) {
    if (!socialSecurityNumber || socialSecurityNumber.length !== 11) {
        return false;
    }

    const birthday = socialSecurityNumber.substring(0, 6);
    if (!validateDateString(birthday)) {
        return false;
    }

    const upperRegex = /[A-Z]/;
    const digitRegex = /[0-9]/;

    const separator = socialSecurityNumber[6];
    if (!upperRegex.test(separator) && separator !== "-") {
        return false;
    }

    const ordinalNumber = socialSecurityNumber.substring(7, 10);
    if (!Number.isSafeInteger(+ordinalNumber) || !Number.isFinite(+ordinalNumber) || +ordinalNumber <= 0) {
        return false;
    }

    const checksum = socialSecurityNumber[10];

    return upperRegex.test(checksum) || digitRegex.test(checksum);
}

export function validateForm(form) {
    let isFormValid = true;

    const { phoneNumber, email, startDate, streetAddress, zip, city, agreement, billingAddress, billingAreaCode, billingTown, billingAddressSameAsMail, multiPersonContract, secondPersonFirstName, secondPersonLastName, secondPersonEmail, secondPersonSocialSecurityNumber } = form.registration;

    if (phoneNumber == null || phoneNumber.length === 0) {
        isFormValid = false;
    }

    if (!validatesEmailForm(email)) {
        isFormValid = false;
    }

    if (startDate == null || startDate.length === 0) {
        isFormValid = false;
    }

    if (streetAddress == null || streetAddress.length === 0) {
        isFormValid = false;
    }

    if (zip == null || zip.length === 0) {
        isFormValid = false;
    }

    if (city == null || city.length === 0) {
        isFormValid = false;
    }

    if (agreement == null || agreement === false) {
        isFormValid = false;
    }
    if(billingAddressSameAsMail === false){
        if (billingAddress == null || billingAddress.length === 0){
            isFormValid = false;
        }
        if (billingAreaCode == null || billingAreaCode.length === 0 ){
            isFormValid = false;
        }
        if(billingTown == null || billingTown.length === 0){
            isFormValid = false;
        }
    }

    if (multiPersonContract) {
        if (secondPersonFirstName == null || secondPersonFirstName.length === 0) {
            isFormValid = false;
        }
        if (secondPersonLastName == null || secondPersonLastName.length === 0) {
            isFormValid = false;
        }
        if (!validatesEmailForm(secondPersonEmail)) {
            isFormValid = false;
        }
        isFormValid = validateSocialSecurityNumber(secondPersonSocialSecurityNumber);
    }

    return isFormValid;
}

export function getDateForDaysAhead(daysAhead) {
    const timeZone = 'Helsinki/Finland';
    const timeUnit = 'days';
    return new Date(momentTimezone(moment().add(daysAhead, timeUnit), timeZone).format());
}

export function getDateWithTimezone(date){
    const timeZone = 'Helsinki/Finland';
    return new Date(momentTimezone(moment(date,"YYYY-MM-DD"),timeZone).format());
}
